import React, { Component } from 'react';
import {StandardPage} from "../../Common/pages/StandardPage";
import HorseRacingGoingContainer from "./HorseRacingGoingContainer";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class HorseRacingGoingPage extends Component {
  render() {
    const { location, params } = this.props;

    return (
      <StandardPage sport="racing" title="Going" >
        <div className="main-layout-left-column">
          <div className="main-layout-block last-desktop last-handheld">
            <HorseRacingGoingContainer location={location} params={params} />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingGoingPage.js